export default __webpack_public_path__ + "static/media/delivery-chalan.508e3ce6.svg";